import { LocationMarkerIcon } from '@heroicons/react/outline';
import React from 'react';
import cx from 'classnames';
export default function Address({
  addressData: data,
  className,
  isShowDefault = false
}) {
  return (
    <div className={cx('address-section', className)}>
      <div className="info">
        <LocationMarkerIcon className="h-6 w-6 stroke-1" />
        <span className="fullname">{data?.fullname}</span>
        <i></i>
        <span className="phone">{data?.phone}</span>
      </div>
      <span className="address px-6 text-sm">{`${data?.address}, ${data?.ward}, ${data?.district}, ${data?.province}`}</span>
      {data?.isDefault && isShowDefault && (
        <div className="default">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          <span>Giao đến địa chỉ này</span>
        </div>
      )}
    </div>
  );
}
